import { Citation } from '#/api'
import { CommandBarButton } from '@fluentui/react'
import styles from './GeneralReferences.module.css'

type GeneralReferencesProps = {
  citations: Citation[]
  onReferenceClick: (citation: Citation) => void
  onDownloadClick: (citation: Citation) => void
}

export const GeneralReferences = ({ citations, onReferenceClick, onDownloadClick }: GeneralReferencesProps) => {
  const filePathTruncationLimit = 40

  const createCitationFilepath = (
    citation: Citation,
    index: number,
    truncate: boolean = false,
    totalCitations: number = 1
  ): string => {
    let citationFilename = ''
    const isSingleSnippet = totalCitations === 1
    const isDocument = !citation.chunk_id

    const label = isSingleSnippet || isDocument ? '' : 'Part'

    let part_i: string | number = ''
    if (citation.part_index !== undefined) {
      part_i = typeof citation.part_index === 'number' ? citation.part_index.toFixed(1) : citation.part_index
    } else if (citation.chunk_id) {
      const parsed = parseFloat(citation.chunk_id)
      part_i = isNaN(parsed) ? citation.chunk_id : parsed.toFixed(1)
    }

    if (citation.title) {
      if (truncate && citation.title.length > filePathTruncationLimit) {
        const citationLength = citation.title.length
        citationFilename = `${citation.title.substring(0, 20)}...${citation.title.substring(citationLength - 20)}${label ? ` - ${label} ${part_i}` : ''}`
      } else {
        citationFilename = `${citation.title}${label ? ` - ${label} ${part_i}` : ''}`
      }
    } else if (citation.filepath) {
      citationFilename = `${citation.filepath}${label ? ` - ${label} ${citation.reindex_id}` : ''}`
    } else {
      citationFilename = `Citation ${index}`
    }

    return citationFilename
  }

  return (
    <div className={styles.citationWrapper}>
      {citations.map((citation, idx) => {
        return (
          <div style={{ float: 'left' }}>
            <span
              style={{ display: 'inline' }}
              title={createCitationFilepath(citation, ++idx, false, citations.length)}
              tabIndex={0}
              role="link"
              key={idx}
              onClick={() => onReferenceClick(citation)}
              onKeyDown={e => (e.key === 'Enter' || e.key === ' ' ? onReferenceClick(citation) : null)}
              className={styles.citationContainer}
              aria-label={createCitationFilepath(citation, idx, false, citations.length)}>
              <div className={styles.citation}>{citation.reference?.replace(/[^a-zA-Z0-9]/g, '')}</div>
              {createCitationFilepath(citation, idx, true, citations.length)}
            </span>
            <span style={{ display: 'inline' }}>
              <CommandBarButton
                role="button"
                style={{ top: '50%', transform: 'translateY(-50%)' }}
                className={styles.downloadFile}
                iconProps={{ iconName: 'Download' }}
                onClick={() => onDownloadClick(citation)}
                aria-label="download file"
              />{' '}
            </span>
            {}
          </div>
        )
      })}
    </div>
  )
}
